/** Base layout shared by every button — height follows content + padding. */
export var BUTTON_BASE = "inline-flex items-center justify-center gap-2 rounded-sds-200 transition-colors disabled:cursor-not-allowed disabled:opacity-60";

/** Padding-based size classes for buttons with a label. */
export var BUTTON_SIZE = {
  sm: "px-3 py-2 text-style-body-small-strong",
  md: "px-4 py-3 text-style-body-small-strong"
};

/** Square padding for icon-only buttons. */
export var BUTTON_ICON_ONLY_SIZE = {
  sm: "p-2",
  md: "p-3"
};

/** Filled colours per intent (primary variant). */
export var BUTTON_PRIMARY = {
  base: "bg-sds-base-tertiary text-sds-base-default hover:bg-sds-base-secondary",
  brand: "bg-sds-brand-default text-sds-brand-on-brand hover:bg-sds-brand-default-hover",
  attention: "bg-sds-attention-default text-sds-attention-on-attention hover:bg-sds-attention-default-hover",
  urgent: "bg-sds-urgent-default text-sds-urgent-on-urgent hover:bg-sds-urgent-default-hover",
  success: "bg-sds-success-default text-sds-success-on-success hover:bg-sds-success-default-hover"
};

/** Text colours and subtle hover per intent (ghost variant). */
export var BUTTON_GHOST = {
  base: "text-sds-base-secondary hover:bg-sds-base-secondary hover:text-sds-base-default",
  brand: "text-sds-brand-default hover:bg-sds-brand-tertiary",
  attention: "text-sds-attention-on-attention hover:bg-sds-attention-secondary",
  urgent: "text-sds-urgent-default hover:bg-sds-urgent-tertiary",
  success: "text-sds-success-default hover:bg-sds-success-tertiary"
};

/** Neutral outlined style (secondary variant). */
export var BUTTON_SECONDARY = "border border-sds-base-default bg-sds-base-default text-sds-base-secondary hover:border-sds-brand-default hover:text-sds-brand-default";